export class GrowerProgramsData {
  id: number;
  spendID: number;
  programName: string;
  budgetName: string;
  retailerName: string;
  seller: string;
  salesChannel: string;
  marketingBrand: string;
  productLine: string;
  estimatedQuantity: number;
  estimatedAmountToPay: number;
  approvedAmountToPay: number;
  customerCreditAmount: number;
  retailerAccountNumber: number;
  programMasterID: number;
  budgetID: number;
  tag: any;
  sellerAccountNumber: number;
  productSegmentId: number;
  isSelected: boolean;
  lineErrors = new LineError();
  lineError = false;
  growerNumber: number;
  isExistingRecord: boolean;
  budgetFilteredList: any[] = [];
  retailerFilteredList: any[] = [];
  programFilteredList: any[] = [];
  productLineId: string;
  marketingBrandId: string;
  isSellerActive: boolean;
  isGrowerActive: boolean;
  isSpendDisabled: boolean;
  hasApprovalAccess: boolean;
  isAlBuFlagAdd: boolean;
  hasAlBuFlagData: boolean;
  approvalStatus: string;
  status: string;
  level: string;
  jdeorderNumber: number;
  jdeorderType: string;
  programType: string;
  cropYear: number;
  budgetUser: number;
  budgetUserName: string;
  voided: boolean;
  voidReason: string;
}
export class GrowerProgramFormsData {
  growerProgramsData: Array<GrowerProgramsData> = [];
}
export class LineError {
  itemId: number;
  errors: Array<string> = [];
}
